import type { ReactNode } from "react";

import { cn } from "@/components/ui/utils";

export function MultiColumnView({
  isDetailView,
  nav,
  children,
}: {
  children: ReactNode;
  nav: ReactNode;
  isDetailView: boolean;
}) {
  return (
    <div className="flex w-full flex-1 overflow-hidden">
      <div
        className={cn(
          "border-r overflow-auto relative shrink-0 w-full lg:w-[300px]",
          isDetailView && "hidden lg:block",
        )}
      >
        <div className="w-full divide-y">{nav}</div>
      </div>
      <div
        className={cn(
          "flex-1 flex flex-col overflow-hidden",
          !isDetailView && "hidden md:block",
        )}
      >
        {children}
      </div>
    </div>
  );
}
